<template>
  <el-dialog
      title="定时设置"
      :visible.sync="localVisible"
      width="60%"
      @close="handleClose"
  >
    <el-form :model="form" label-width="120px">
      <div class="section">
        <div class="section-header">
          <h4>定时任务设置</h4>
          <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              @click="addSchedule"
          >添加定时任务
          </el-button>
        </div>

        <div
            v-for="(item, index) in form.schedules"
            :key="'schedule-'+index"
            class="input-item"
        >
          <el-form-item label="是否启用">
            <el-switch v-model="item.active"></el-switch>
          </el-form-item>
          <el-form-item label="定时规则">
            <div class="cron-fields">
              <el-form-item label="年" class="compact-field">
                <el-input v-model="item.trigger.year" placeholder="如: 2025" style="width: 90px"></el-input>
              </el-form-item>
              <el-form-item label="月" class="compact-field">
                <el-input v-model="item.trigger.month" placeholder="1-12" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="周" class="compact-field">
                <el-input v-model="item.trigger.week" placeholder="1-53" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="日" class="compact-field">
                <el-input v-model="item.trigger.day" placeholder="1-31" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="星期" class="compact-field">
                <el-input v-model="item.trigger.day_of_week" placeholder="0-6" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="时" class="compact-field">
                <el-input v-model="item.trigger.hour" placeholder="0-23" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="分" class="compact-field">
                <el-input v-model="item.trigger.minute" placeholder="0-59" style="width: 60px"></el-input>
              </el-form-item>
              <el-form-item label="秒" class="compact-field">
                <el-input v-model="item.trigger.second" placeholder="0-59" style="width: 60px"></el-input>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="选择函数" required>
            <el-select
                v-model="item.func_name"
                filterable
                placeholder="请选择要执行的函数"
                style="width: 100%"
                @change="handleFunctionChange(index)"
            >
              <el-option
                  v-for="func in functionList"
                  :key="func.id"
                  :label="func.name"
                  :value="func.name"
              >
                <span style="float: left">{{ func.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ func.description }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <div v-if="item.kwargs && Object.keys(item.kwargs).length > 0" class="kwargs-section">
            <div class="kwargs-header">函数参数设置</div>
            <div class="kwargs-content">
              <el-form-item
                  v-for="(param, key) in item.kwargs"
                  :key="key"
                  :label="key"
              >
                <el-input
                    v-model="item.kwargs[key]"
                    :placeholder="`请输入${paramsProperties[key]?.description || key}`"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="消息提醒">
            <el-checkbox-group v-model="item.notifications">
              <el-checkbox label="internal">站内消息</el-checkbox>
              <el-checkbox label="email">邮件通知</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <template v-if="item.notifications.length > 0">
            <el-form-item label="消息内容">
              <el-input
                  type="textarea"
                  v-model="item.content"
                  placeholder="请输入消息内容"
                  :rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="提示词">
              <el-input
                  type="textarea"
                  v-model="item.prompt"
                  placeholder="请输入提示词"
                  :rows="2"
              ></el-input>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="removeSchedule(index)"
                :disabled="item.active"
            >删除
            </el-button>
            <span v-if="item.active" style="color: #f56c6c; margin-left: 10px; font-size: 12px">
              请先关闭任务再删除
            </span>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="localVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {scheduleApi} from '@/api/schedule_api';
import {botFuncApi} from '@/api/bot_func';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    botData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localVisible: this.visible,
      paramsProperties: {}, // 存储参数属性
      form: {
        bot_id: '',
        schedules: [{
          active: false,
          trigger_type: 'cron',
          trigger: {
            year: '',
            month: '',
            week: '',
            day: '',
            day_of_week: '',
            hour: '',
            minute: '',
            second: ''
          },
          func_name: '',
          notifications: [],
          content: '',
          prompt: '',
          kwargs: {} // 新增参数对象
        }]
      },
      functionList: [],
      loading: false,
    }
  },
  methods: {
    async handleFunctionChange(index) {
      const selectedFunc = this.functionList.find(
        func => func.name === this.form.schedules[index].func_name
      );
      if (selectedFunc && selectedFunc.params_properties) {
        this.paramsProperties = selectedFunc.params_properties;
        // 使用Vue.set确保响应式更新
        this.$set(this.form.schedules[index], 'kwargs', 
          Object.keys(selectedFunc.params_properties).reduce((acc, key) => {
            acc[key] = '';
            return acc;
          }, {})
        );
      } else {
        this.$set(this.form.schedules[index], 'kwargs', {});
      }
    },
    handleClose() {
      this.localVisible = false;
      this.$emit('update:visible', false);
      this.$emit('reloadBotList');
    },
    async handleSubmit() {
      const res = await scheduleApi.saveOrUpdateSchedule({
        bot_id: this.form.bot_id,
        schedules: this.form.schedules
      });
      this.$emit('success', res.data);
      this.$emit('reloadBotList');
      this.handleClose();
    },
    addSchedule() {
      this.form.schedules.push({
        active: false,
        trigger_type: 'cron',
        trigger: {
          year: '',
          month: '',
          week: '',
          day: '',
          day_of_week: '',
          hour: '',
          minute: '',
          second: ''
        },
        func_name: '',  // 修改为func_name
        notifications: [],
        content: '',
        prompt: '',
        kwargs: {}
      });
    },
    initDefaultSchedule() {
      this.form.schedules = [{
        active: false,
        trigger_type: 'cron',
        trigger: {
          year: '',
          month: '',
          week: '',
          day: '',
          day_of_week: '',
          hour: '',
          minute: '',
          second: ''
        },
        func_name: '',  // 修改为func_name
        notifications: [],
        content: '',
        prompt: '',
        kwargs: {}
      }];
    },
    removeSchedule(index) {
      if (this.form.schedules[index].active) {
        this.$message.warning('请先关闭任务再删除');
        return;
      }
      this.form.schedules.splice(index, 1);
    },
    async fetchFunctionList() {
      this.loading = true;
      try {
        const res = await botFuncApi.getFunctions();
        this.functionList = res.data || [];
      } catch (error) {
        this.$message.error('获取函数列表失败');
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchFunctionList();
  },
  watch: {
    visible: {
      handler(val) {
        this.localVisible = val;
      },
      immediate: true
    },
    botData: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.form.bot_id = val.id;
          try {
            const res = await scheduleApi.getScheduleDetail(val.id);
            if (res.data && res.data.length > 0) {
              this.form.schedules = res.data.map(item => ({
                id: item.id,
                active: item.active || false,
                trigger_type: item.trigger_type || 'cron',
                trigger: item.trigger || {
                  year: '',
                  month: '',
                  week: '',
                  day: '',
                  day_of_week: '',
                  hour: '',
                  minute: '',
                  second: ''
                },
                func_name: item.func_name || '',  // 修改为func_name
                notifications: item.notifications || [],
                content: item.content || '',
                prompt: item.prompt || '',
                kwargs: item.kwargs || {}
              }));
            } else {
              this.initDefaultSchedule();
            }
          } catch (error) {
            this.$message.error('获取定时任务失败');
            this.initDefaultSchedule();
          }
        } else {
          this.initDefaultSchedule();
        }
      }
    }
  }
}
</script>

<style scoped>
.kwargs-section {
  margin: 15px 0;
  padding: 15px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background-color: #fafafa;
}

.kwargs-header {
  font-weight: bold;
  color: #606266;
  margin-bottom: 10px;
}

.kwargs-content {
  margin-left: 20px;
}

/* 保留原有样式 */
.section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-header h4 {
  margin: 0;
  color: #606266;
}

.input-item {
  margin-bottom: 25px;
  padding: 15px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  position: relative;
}

.cron-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.compact-field {
  margin-bottom: 0;
}

.compact-field :deep(.el-form-item__label) {
  padding-right: 5px;
  width: auto !important;
}

.compact-field :deep(.el-form-item__content) {
  margin-left: 0 !important;
}
</style>